import * as api from 'services/api';

// Set to false when backend endpoint is ready
const USE_MOCK_API = false;

export const submitContactForm = (formData) => (dispatch) => {
  if (USE_MOCK_API) {
    // Mock for testing - simulates API call
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ message: 'Form submitted successfully' });
      }, 1000);
    });
  } else {
    // Real API call - use when backend endpoint is ready
    return api.post('contact-form', formData, 'SUBMIT_CONTACT_FORM', dispatch);
  }
};
